export default function (props: any) {
    return (
        <svg width="20" height="20" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" {...props}>
            <defs>
                <filter colorInterpolationFilters="auto" id="a">
                    <feColorMatrix in="SourceGraphic" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0" />
                </filter>
            </defs>
            <g transform="translate(-1250 -13)" filter="url(#a)" fill="none" fillRule="evenodd">
                <path d="M1250 13.533h30v29h-30z" />
                <path
                    d="M1271.657 34.468a3.28 3.28 0 0 1-.746.561c-.24.125-.495.057-.765-.204L1265 29.85l-5.164 4.992c-.258.25-.507.312-.747.187a3.28 3.28 0 0 1-.746-.56 3.197 3.197 0 0 1-.58-.722c-.13-.232-.065-.472.193-.721l5.165-4.993-5.146-4.974c-.27-.261-.341-.508-.212-.74.129-.23.322-.471.58-.72a3.28 3.28 0 0 1 .746-.562c.24-.124.495-.056.765.205l5.146 4.975 5.146-4.975c.258-.25.51-.315.755-.196.246.119.498.303.756.552.258.25.448.493.571.73.123.238.055.482-.203.731l-5.146 4.974 5.146 4.975c.27.261.341.507.212.739a3.197 3.197 0 0 1-.58.721z"
                    fill="#FA6400"
                />
            </g>
        </svg>
    );
}
